<template>
  <div>
    <hi-card v-for="(item, index) in detailsList" :key="item.id || index" :row-index="index + 1">
      <van-row class="detail-row">
        <span>大宗原料编码：</span>
        <span>{{ item.commodityCode }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>大宗原料名称：</span>
        <span>{{ item.commodityName }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>行情来源月份：</span>
        <span>{{ item.quotationMonth }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>行情单价：</span>
        <span>{{ item.quotationPrice }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>行情计价单位：</span>
        <span>{{ item.quotationUnit | dictFilter(quotationUnitOptions) }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>定价币种：</span>
        <span>{{ item.currencyDict | dictFilter(currencyOptions) }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>供应商编号：</span>
        <span>{{ item.suppId }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>供应商名称：</span>
        <span>{{ item.suppName }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>行情库现最新价格：</span>
        <span>{{ item.currentQuotationPrice }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>涨跌幅(%)：</span>
        <span>{{ item.priceChangePercent }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'CommodityQuotationApplyDetailList',
  props: {
    detailsList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    quotationUnitOptions() {
      return this.$store.getters.dicts.quotation_price_unit
    },
    currencyOptions() {
      return this.$store.getters.dicts.currency_dict
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-row span:first-child {
  color: #666666;
}
.detail-row span:last-child {
  color: #262626;
}
</style>
